<template>
  <v-snackbar v-model="value" :color="color" data-cy="snackbar">
    {{ text }}
    <template v-slot:action="{ attrs }">
      <v-btn text v-bind="attrs" @click.native="value = false" outlined>{{
        $t("Close")
      }}</v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Snackbar",
  computed: {
    ...mapState("snackbar", ["color", "text"]),
    value: {
      get() {
        return this.$store.state.snackbar.value;
      },
      set(value) {
        this.$store.commit("snackbar/setValue", value);
      },
    },
  },
};
</script>